export const USER_DEFINED_EDITOR_HEIGHT_PERCENTAGE = 'USER_DEFINED_EDITOR_HEIGHT_PERCENTAGE'; // key for storing user heights